import React from "react";
import { Info } from "lucide-react";
import { cn } from "../lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export const KpiCard = ({ label, value, hint, sub, icon: Icon, tone = "default", testId }) => (
  <div className="ll-card p-4 md:p-5" data-testid={testId || "kpi-card"}>
    <div className="flex items-start justify-between gap-2">
      <div className="flex items-center gap-2">
        {Icon ? (
          <span
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-lg",
              tone === "primary" && "bg-primary/10 text-primary",
              tone === "amber" && "bg-amber-100 text-amber-700",
              tone === "blue" && "bg-blue-50 text-blue-700",
              tone === "default" && "bg-muted text-muted-foreground"
            )}
          >
            <Icon className="h-4 w-4" />
          </span>
        ) : null}
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          {label}
        </span>
      </div>
      {hint ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label={`About ${label}`}
                className="text-muted-foreground/70 hover:text-foreground"
              >
                <Info className="h-3.5 w-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent className="max-w-[220px] text-xs">{hint}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : null}
    </div>
    <div
      className="ll-num mt-3 font-display text-2xl font-semibold md:text-3xl"
      data-testid="kpi-card-value"
    >
      {value}
    </div>
    {sub ? (
      <div className="mt-1 text-xs text-muted-foreground" data-testid="kpi-card-sub">
        {sub}
      </div>
    ) : null}
  </div>
);

export default KpiCard;
